// extracted by mini-css-extract-plugin
module.exports = {"h6":"h6__sksEc","p":"p__MIDxN","event":"event__COgRq","eventDetail":"eventDetail__EJTWA","eventIcon":"eventIcon__0He5-","eventTime":"eventTime__HsTHv"};